







































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { ReferralNode } from '@/api/model/referral-node'
import { TargetDirection } from '@/api/types'
import { CompanyAPI } from '@/api/backend-client'
import { UserTarget } from '@/api/model/user-target'
import { PipelineAPI } from '@/api/backend-client'
import { Pipeline } from '@/api/model/pipeline'

@Component
export default class EditUserTargetForm extends Vue {
    @Prop() readonly value!: UserTarget
    loadingReferralPipelines: boolean = true
    referralPipelines: Pipeline[] = []
    loadingOrderTypes: boolean = true
    orderTypes: string[] = []

    mounted() {
        this.loadReferralPipelines()
        this.loadOrderTypes()
    }

    async loadReferralPipelines(): Promise<void> {
        this.loadingReferralPipelines = true
        this.referralPipelines = await PipelineAPI.getAll({ company: this.$currentCompany.id })
        this.loadingReferralPipelines = false
    }

    async loadOrderTypes(): Promise<void> {
        this.loadingOrderTypes = true

        // Reset order types
        this.orderTypes = []

        // Ensure referralNodes are loaded
        await this.$currentCompany.ensureIncomingReferralsAreLoaded()
        await this.$currentCompany.ensureOutgoingReferralsAreLoaded()

        // Determine companies
        const companyIds = [...new Set([
            ...[this.$currentCompany.id],
            ...this.$currentCompany.incomingReferrals.map((node: ReferralNode) => node.source.id),
            ...this.$currentCompany.outgoingReferrals.map((node: ReferralNode) => node.target.id),
        ])].filter(companyId => companyId !== undefined)

        // Determine order types handled by companies
        for (const companyId of companyIds) {
            try {
                const orderSettings = await CompanyAPI.getOrderSettings(companyId)
                if (orderSettings) {
                    this.orderTypes = this.orderTypes.concat(orderSettings.enabledTypes)
                }
            } catch (error) {
                // Ignore
            }
        }

        this.orderTypes = [...new Set(this.orderTypes)]

        this.loadingOrderTypes = false
    }

    get referralPipelineOptions() {
        return this.referralPipelines
            .map(referralPipeline => {
                return {
                    label: referralPipeline.name,
                    value: referralPipeline.id,
                }
            })
            .sort((a, b) => a.label.toString().localeCompare(b.label.toString()))
    }

    get referralPipeline(): string|null {
        return this.value.referralPipeline ? this.value.referralPipeline.id : null
    }

    set referralPipeline(referralPipelineId: string|null) {
        let referralPipeline = null

        if (referralPipelineId) {
            referralPipeline = this.referralPipelines.find(rp => rp.id === referralPipelineId)
        }

        this.value.referralPipeline = referralPipeline
    }

    get referralTypeOptions() {
        return [...new Set([
            ...this.$currentCompany.incomingReferrals,
            ...this.$currentCompany.outgoingReferrals,
        ].map((node: ReferralNode) => node.type))]
            .map(type => ({
                label: this.$t(`referral.type.${type}`),
                value: type,
            }))
            .sort((a, b) => a.label.toString().localeCompare(b.label.toString()))
    }

    get orderTypeOptions() {
        return this.orderTypes
            .map(orderType => {
                return {
                    label: this.$t(`order.type.${orderType}`),
                    value: orderType,
                }
            })
            .sort((a, b) => a.label.toString().localeCompare(b.label.toString()))
    }

    get directionOptions() {
        return [
            {
                label: this.$t('target.direction.out'),
                value: TargetDirection.OUT,
            },
            {
                label: this.$t('target.direction.in'),
                value: TargetDirection.IN,
            },
        ]
    }
}
